import { render, staticRenderFns } from "./UserDetailsButton.vue?vue&type=template&id=f27304ea&"
import script from "./UserDetailsButton.vue?vue&type=script&lang=js&"
export * from "./UserDetailsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports